import { useCurrentFrame, interpolate } from 'remotion';

/**
 * VS 2022-style menu dropdown overlay for video rendering.
 * Shows a dropdown menu with items, matching dark theme styling.
 */
export default function MenuDropdown({ items = [], x = 0, y = 30 }) {
  const frame = useCurrentFrame();

  // Fade in over 8 frames
  const opacity = interpolate(frame, [0, 8], [0, 1], { extrapolateRight: 'clamp' });

  return (
    <div style={{
      position: 'absolute', left: x, top: y,
      background: '#252526', border: '1px solid #454545',
      borderRadius: 2, minWidth: 240,
      boxShadow: '0 2px 8px rgba(0,0,0,0.5)',
      opacity, zIndex: 200,
      fontFamily: "'Segoe UI', sans-serif", fontSize: 12,
    }}>
      <div style={{ padding: '4px 0' }}>
        {items.map((item, i) => {
          if (item.separator) {
            return <div key={i} style={{ height: 1, background: '#454545', margin: '4px 0' }}/>;
          }
          return (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '4px 28px 4px 32px', height: 24, cursor: 'default',
              background: item.highlight ? '#094771' : 'transparent',
              color: item.highlight ? '#fff' : '#ccc',
            }}>
              <span>{item.label}</span>
              {item.shortcut && (
                <span style={{ color: '#858585', fontSize: 11, marginLeft: 24 }}>{item.shortcut}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
